module.exports = __webpack_public_path__ + "static/media/burger.9c90613c.svg";